import React, { useEffect, useState, useContext, useRef } from "react";
import {
  Typography,
  Stack,
  Box,
  Grid,
  Button,
  TextField,
} from "@mui/material";
import { Link } from "react-router-dom";
import { useDownloadExcel } from "react-export-table-to-excel";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
//Icons
import { SiMicrosoftexcel } from "react-icons/si";
//Srcs
import "../../Style/pagestyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import StudStatisticSchoolFee from "./StudStatisticSchoolFee";
import StudStatisticMonthlyFee from "./StudStatisticMonthlyFee";
import StudentStatisticByClassgroup from "./StudentStatisticByClassgroup";
import StudStatisticByAcademicYear from "./StudStatisticByAcademicYear";
import {
  SelectAcademicYear,
  SelectProgrammeList,
  SelectProgramme,
  SelectClassGroup,
} from "../Include/DynamicSelect";

export default function StudStatisti() {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);

   //print
   const componentRef = useRef();
   const handlePrint = useReactToPrint({
     content: () => componentRef.current,
   });
 

  const [academicYearVal, setAcademicYearVal] = useState({ id: "", title: "" });
  const [oldAcademicYearVal, setOldAcademicYearVal] = useState({ id: "", title: "" });
  const [programmeVal, setProgrammeVal] = useState({ id: "", title: "" });
  const [classGroupVal, setClassGroupVal] = useState({ id: "", title: "" });
  const [programmeListVal, setProgrammeListVal] = useState([]);
  const [programmeListId, setProgrammeListId] = useState([]);

  // const handlePrintClassgroup = () => {
  //   handlePrint
  // }

  let tabStudentStatisticFromLocal = JSON.parse(window.localStorage.getItem("tabStudentStatistic"));
  const [tabValue, setTabValue] = useState(tabStudentStatisticFromLocal ? tabStudentStatisticFromLocal : "byClassgroup");
  const [filterMonthYear, setFilterMonthYear] = useState(moment());

  const handleByClassgroup = () => {
    setTabValue("byClassgroup")
    window.localStorage.setItem("tabStudentStatistic", JSON.stringify("byClassgroup"));
  }

  const handleByClass = () => {
    setTabValue("byClass")
    window.localStorage.setItem("tabStudentStatistic", JSON.stringify("byClass"));
  }

  const handleMonthFee = () => {
    setTabValue("MonthFee")
    window.localStorage.setItem("tabStudentStatistic", JSON.stringify("MonthFee"));
  }

  const handleSchoolFee = () => {
    setTabValue("SchoolFee")
    window.localStorage.setItem("tabStudentStatistic", JSON.stringify("SchoolFee"));
  }

  // window.localStorage.setItem("userLogin", JSON.stringify(getUserLogin));

  useEffect(() => {
    if (programmeListVal?.length !== 0) {
      const newProgrammeList = programmeListVal?.map((row) => row?.id);
      setProgrammeListId(newProgrammeList);
    } else {
      setProgrammeListId([]);
    }
  }, [programmeListVal?.length]);

  useEffect(() => {
    if (academicYearVal === null || academicYearVal?.id) {
      setProgrammeListVal([]);
      setProgrammeListId([]);
      setProgrammeVal({ id: "", title: "" });
      setClassGroupVal({ id: "", title: "" });
    }
  }, [academicYearVal]);

  useEffect(() => {
    if (programmeVal === null || programmeVal?.id) {
      setClassGroupVal({ id: "", title: "" });
    }
  }, [programmeVal]);

  // =================== Export to excel school fee ===================
  const [checkExport, setCheckExport] = useState(false);
  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename:
      tabValue === "SchoolFee"
        ? "Student-Payment-Detail"
        : tabValue === "Enrollment"
          ? "Student-Enrollment-Detail"
          : tabValue === "MonthFee"
            ? "Month-Fee-payement"
            : "",
    sheet: "Student-Payment",
  });
  const handleExportExcel = () => {
    setCheckExport(true);
    setTimeout(() => {
      onDownload();
      setCheckExport(false);
    }, 2000);
  };

  return (
    <div className="page-container">
      <Stack direction="row" spacing={2} className="page-header">
        <Stack direction="row" spacing={2}>
          <Box className="slash" />
          <Stack direction="column" justifyContent="center">
            <Link to="/report" className="page-link-title">
              <Typography className="page-title">Report</Typography>
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="page-title">
              Student Statistics By Class
            </Typography>
          </Stack>
        </Stack>
        <Box sx={{ flexGrow: 1 }} />

        <Stack direction="row" spacing={0.6}>
          <Stack direction="column" justifyContent="center">
            <Link className="page-link-title" to="/">
              {t("page_dashboard")}
            </Link>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">/</Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <Typography className="breadcrumbs-title">
              Student Statistics By Class
            </Typography>
          </Stack>
        </Stack>
      </Stack>

      <Box sx={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Stack direction="row">
              <Button
                sx={{ width: "140px" }}
                onClick={handleByClassgroup}
                className={
                  tabValue === "byClassgroup" ? "active-tab" : "inactive-tab"
                }
              >
                By Classgroup
              </Button>
              <Button
                sx={{ width: "120px" }}
                onClick={handleByClass}
                className={
                  tabValue === "byClass" ? "active-tab" : "inactive-tab"
                }
              >
                By Class
              </Button>
              {/* <Button
                sx={{ width: "120px" }}
                onClick={handleSchoolFee}
                className={
                  tabValue === "SchoolFee" ? "active-tab" : "inactive-tab"
                }
              >
                School Fee
              </Button>
              <Button
                sx={{ width: "120px" }}
                onClick={handleMonthFee}
                className={
                  tabValue === "MonthFee" ? "active-tab" : "inactive-tab"
                }
              >
                Month Fee
              </Button> */}
            </Stack>
          </Grid>
          <Grid item xs={6} sm={4} md={3} lg={3} xl={2.4}>
            <Typography className="search-head-title">
              Select academic year
            </Typography>
            <SelectAcademicYear
              selectedVal={academicYearVal}
              setSelectedVal={setAcademicYearVal}
              className="search-field"
            />
          </Grid>
          {
            tabValue === "byClassgroup" || tabValue === "byClass" ?
              <Grid item xs={6} sm={4} md={3} lg={3} xl={2.4}>
                <Typography className="search-head-title">
                  Select old academic
                </Typography>
                <SelectAcademicYear
                  selectedVal={oldAcademicYearVal}
                  setSelectedVal={setOldAcademicYearVal}
                  className="search-field"
                />
              </Grid> : null
          }
          <Grid item xs={6} sm={6} md={4} lg={4} xl={3}>
            <Typography className="search-head-title">
              Select programme
            </Typography>
            {tabValue === "MonthFee" || tabValue === "byClass" ? (
              <SelectProgramme
                className={"search-field"}
                selectedVal={programmeVal}
                setSelectedVal={setProgrammeVal}
                disabled={academicYearVal?.id ? false : true}
              />
            ) : (
              <SelectProgrammeList
                selectedVal={programmeListVal}
                setSelectedVal={setProgrammeListVal}
                className={"search-field"}
                checkedDisabled={academicYearVal?.id}
              />
            )}
          </Grid>
          {tabValue === "MonthFee" || tabValue === "byClass" ? (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
              <Typography className="search-head-title">
                Select class group
              </Typography>
              <SelectClassGroup
                className={"search-field"}
                selectedVal={classGroupVal}
                setSelectedVal={setClassGroupVal}
                programmeId={programmeVal?.id}
              />
            </Grid>
          ) : null}
          {tabValue === "MonthFee" ? (
            <Grid item xs={6} sm={6} md={4} lg={3} xl={2.4}>
              <Typography className="search-head-title">
                Month and year
              </Typography>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  views={["month", "year"]}
                  inputFormat="MMMM-yyyy"
                  mask="__-__-____"
                  value={filterMonthYear}
                  onChange={(newValue) => {
                    setFilterMonthYear(newValue);
                  }}
                  className="search-field"
                  renderInput={(params) => (
                    <TextField {...params} size="small" fullWidth />
                  )}
                />
              </LocalizationProvider>
            </Grid>
          ) : null}
          <Box sx={{ flexGrow: 1 }} />
          {/* {tabValue === "Enrollment" ?
            <Grid item xs={3} sm={3} md={3} lg={1.5} xl={1}>
              <Stack direction="row" justifyContent="right">
                <Button
                  className="btn-create"
                  startIcon={
                    <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                  }
                  onClick={handleExportExcelEnroll}
                >
                  Export
                </Button>
              </Stack>
            </Grid>
            : null} */}
          {/* {tabValue === "SchoolFee" ? */}
          <Grid item xs={3} sm={3} md={3} lg={1.5} xl={1.6}>
            <Stack direction="row" justifyContent="right" sx={{ width: "100%" }} spacing={1}>
              {
                tabValue === "byClass" ?
                  <Button
                    className="btn-create"
                    startIcon={
                      <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                    }
                    onClick={handlePrint}
                  >
                    Print
                  </Button> : null
              }

              <Button
                className="btn-create"
                startIcon={
                  <SiMicrosoftexcel style={{ height: "18px", width: "18px" }} />
                }
                onClick={handleExportExcel}
              >
                Export
              </Button>
            </Stack>
          </Grid>
          {/* <Grid item xs={3} sm={2} md={1.5} lg={1.5} xl={1}>
            <Stack direction="row" justifyContent="right">
              <ReactToPrint
                content={reactToPrintContent}
                // documentTitle={`Contract-${printData?.title}`}
                removeAfterPrint
                trigger={reactToPrintTrigger}
              />
            </Stack>
          </Grid> */}
        </Grid>
      </Box>

      {tabValue === "byClass" ? (
        <StudentStatisticByClassgroup
          academicYearVal={academicYearVal}
          oldAcademicYearVal={oldAcademicYearVal}
          programmeId={programmeVal?.id}
          classgroupId={classGroupVal?.id}
          classGroupName={classGroupVal?.title}
          componentRef={componentRef}
          tableRef={tableRef}
        />
      ) : null}

      {tabValue === "byClassgroup" ? (
        <StudStatisticByAcademicYear
          academicYearVal={academicYearVal}
          oldAcademicYearVal={oldAcademicYearVal}
          programmeListId={programmeListId}
          tableRef={tableRef}
        />
      ) : null}

      {tabValue === "SchoolFee" ? (
        <StudStatisticSchoolFee
          tableRef={tableRef}
          academicYearVal={academicYearVal}
          programmeListId={programmeListId}
        />
      ) : null}

      {tabValue === "MonthFee" ? (
        <StudStatisticMonthlyFee
          tableRef={tableRef}
          classGroupVal={classGroupVal}
          academicYearVal={academicYearVal}
          programmeVal={programmeVal}
          filterMonthYear={filterMonthYear}
        />
      ) : null}
    </div>
  );
}
